<h3>Error: </h3>
<ul *ngIf="data?.errorCodes?.length">
  <li *ngFor="let error of data?.errorCodes">{{ error?.value }}</li>
</ul>
<p *ngIf="data?.error && !data?.errorCodes?.length">{{data?.error}}</p>